import { fromJS } from 'immutable';

import { LOGOUT } from './auth';

const ENDPOINT = '/api/dwellings';

const LIST_INIT = 'dwellings/LIST_INIT';
const LIST_SUCCESS = 'dwellings/LIST_SUCCESS';
const LIST_FAILED = 'dwellings/LIST_FAILED';

const ACTIVE_DWELLINGS_INIT = 'dwellings/ACTIVE_DWELLINGS_INIT';
const ACTIVE_DWELLINGS_SUCCESS = 'dwellings/ACTIVE_DWELLINGS_SUCCESS';
const ACTIVE_DWELLINGS_FAILED = 'dwellings/ACTIVE_DWELLINGS_FAILED';

const ACTIVATION_INIT = 'dwellings/ACTIVATION_INIT';
export const ACTIVATION_SUCCESS = 'dwellings/ACTIVATION_SUCCESS';
const ACTIVATION_FAILED = 'dwellings/ACTIVATION_FAILED';

const APPROVE_INIT = 'dwellings/APPROVE_INIT';
export const APPROVE_SUCCESS = 'dwellings/APPROVE_SUCCESS';
const APPROVE_FAILED = 'dwellings/APPROVE_FAILED';

const STATUS_CHANGE_INIT = 'dwellings/STATUS_CHANGE_INIT';
export const STATUS_CHANGE_SUCCESS = 'dwellings/STATUS_CHANGE_SUCCESS';
const STATUS_CHANGE_FAILED = 'dwellings/STATUS_CHANGE_FAILED';

const DUPLICATE_INIT = 'dwellings/DUPLICATE_INIT';
const DUPLICATE_SUCCESS = 'dwellings/DUPLICATE_SUCCESS';
const DUPLICATE_FAILED = 'dwellings/DUPLICATE_FAILED';

const VALIDATION_INIT = 'dwellings/VALIDATION_INIT';
const VALIDATION_SUCCESS = 'dwellings/VALIDATION_SUCCESS';
const VALIDATION_FAILED = 'dwellings/VALIDATION_FAILED';

const initialState = fromJS({
  data: [],
  timestamp: null,
  loading: false
});

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT: {
      return initialState;
    }

    case LIST_INIT:
    case ACTIVE_DWELLINGS_INIT:
    case ACTIVATION_INIT:
    case APPROVE_INIT:
    case STATUS_CHANGE_INIT:
    case DUPLICATE_INIT: {
      return state.mergeDeep({ loading: true });
    }
    case LIST_FAILED: {
      return initialState;
    }
    case ACTIVE_DWELLINGS_FAILED:
    case ACTIVATION_FAILED:
    case APPROVE_FAILED:
    case STATUS_CHANGE_FAILED:
    case DUPLICATE_FAILED: {
      return state.mergeDeep({ loading: false });
    }
    case LIST_SUCCESS: {
      return state.mergeDeep({ data: payload, loading: false });
    }
    case ACTIVE_DWELLINGS_SUCCESS: {
      return state.mergeDeep({ actives: payload, loading: false });
    }
    case ACTIVATION_SUCCESS:
    case APPROVE_SUCCESS:
    case STATUS_CHANGE_SUCCESS: {
      const data = state.get('data');
      const index = data.findIndex((item) => item.get('uuid') === payload.uuid);
      if (index === -1) {
        // TODO: Handle error!
        return state.mergeDeep({ loading: false });
      }
      return state.mergeDeep({
        data: data.set(index, fromJS(payload)),
        loading: false
      });
    }
    case DUPLICATE_SUCCESS: {
      return state.mergeDeep({
        data: state.get('data').push(fromJS(payload)),
        loading: false
      });
    }
    default: {
      return state;
    }
  }
}

export function list() {
  return {
    types: [LIST_INIT, LIST_SUCCESS, LIST_FAILED],
    promise: (client) => client.get(ENDPOINT).then(rejectNonOK)
  };
}

export function activeDwellings() {
  return {
    types: [
      ACTIVE_DWELLINGS_INIT,
      ACTIVE_DWELLINGS_SUCCESS,
      ACTIVE_DWELLINGS_FAILED
    ],
    promise: (client) =>
      client.get(`${ENDPOINT}/activeDwellings`).then(rejectNonOK)
  };
}

export function toggleActivation(uuid, active) {
  return {
    types: [ACTIVATION_INIT, ACTIVATION_SUCCESS, ACTIVATION_FAILED],
    promise: (client) =>
      client
        .post(`${ENDPOINT}/${uuid}/activation`, { data: { active } })
        .then(rejectNonOK)
  };
}

export function changeStatus(uuid, { status, reason, mails }) {
  return {
    types: [STATUS_CHANGE_INIT, STATUS_CHANGE_SUCCESS, STATUS_CHANGE_FAILED],
    promise: (client) =>
      client
        .post(`${ENDPOINT}/${uuid}/status`, { data: { status, reason, mails } })
        .then(rejectNonOK)
  };
}

export function approve(uuid, { reason, mails }) {
  return {
    ...changeStatus(uuid, { status: 'APPROVED', reason, mails }),
    types: [APPROVE_INIT, APPROVE_SUCCESS, APPROVE_FAILED]
  };
}

export function reject(uuid, { reason }) {
  return changeStatus(uuid, { status: 'REJECTED', reason });
}

export function duplicate(uuid, location) {
  return {
    types: [DUPLICATE_INIT, DUPLICATE_SUCCESS, DUPLICATE_FAILED],
    promise: (client) =>
      client
        .post(`${ENDPOINT}/${uuid}/duplicate`, { data: { location } })
        .then(({ status, result }) => {
          if (status !== 'OK') {
            throw new Error('Fetch request failed');
          }
          return result;
        })
  };
}

export function validate(uuid) {
  return {
    types: [VALIDATION_INIT, VALIDATION_SUCCESS, VALIDATION_FAILED],
    promise: (client) => client.get(`/api/admin/validate/${uuid}`)
  };
}

function rejectNonOK({ status, result, results }) {
  if (status !== 'OK') {
    throw new Error('Fetch request failed');
  }
  return result || results;
}
